export default __webpack_public_path__ + "static/media/explore-left-section.71fbaaeb.svg";